import { ICamera } from '@api/models';
import {
    IAIEquipmentTrackingErrorReport,
    IAIPeopleDetectionErrorReport,
    IAiSafetyAnalysisErrorReport,
    ICameraInstallationAnalytics,
    ICommentsActivity,
    IInactiveUserEmailLog,
    ILivelapseLogs,
    IMultiImageLogs,
    IProgressLineActivity,
    IPublicApiLogs,
    IScheduledReport,
    IWhatsappActivity,
} from '@api/models/analytics.model';
import { ISigninLog } from '@api/types/sign-in.type';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getLiveLapseLogs = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/livelapse?startDate=${startDate}&endDate=${endDate}`
    );
    return data as ILivelapseLogs[];
};

export const getMultiImageLogs = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/multi-images?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IMultiImageLogs[];
};
export const getPublicApiLogs = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/public-api?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IPublicApiLogs[];
};

export const getCameraImageCommentsActivity = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/camera-image-comments?startDate=${startDate}&endDate=${endDate}`
    );
    return data as ICommentsActivity[];
};
export const getProgressLineActivity = async (startDate?: string, endDate?: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/progressline?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IProgressLineActivity[];
};
export const getScheduledReports = async (startDate?: string, endDate?: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/schedule-reports?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IScheduledReport[];
};
export const getWhatsappActivity = async (startDate?: string, endDate?: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/whatsapp-bot-activation?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IWhatsappActivity[];
};
export const getBimServiced = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/analytics/BIM`);
    return data as ICamera[];
};
export const getAiServiced = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/analytics/AI`);
    return data as ICamera[];
};
export const getInactiveUserEmail = async (startDate?: string, endDate?: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/inactive-user-emails?startDate=${startDate}&endDate=${endDate}`
    );
    return data as IInactiveUserEmailLog[];
};

export const getCameraInstallationAnalytics = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/camera-installations?startDate=${startDate}&endDate=${endDate}`
    );

    return data as ICameraInstallationAnalytics[];
};

export const getAiPeopleFlowWrongInfo = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/ai-people-error-report`
    );
    return data as IAIPeopleDetectionErrorReport[];
};
export const getAiSafetyWrongInfo = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/ai-ppe-error-report`
    );
    return data as IAiSafetyAnalysisErrorReport[];
};
export const getAiEquipmentTrackingWrongInfo = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/ai-equipment-error-report`
    );
    return data as IAIEquipmentTrackingErrorReport[];
};

export const getDailyActivity = async (startDate: string, endDate: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/analytics/user-daily-activity?startDate=${startDate}&endDate=${endDate}`
    );
    return data as ISigninLog[];
};
